var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGameBoardSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 248H232V96C232 91.578 228.422 88 224 88H64C59.578 88 56 91.578 56 96V256C56 260.422 59.578 264 64 264H216V416C216 420.422 219.578 424 224 424H384C388.422 424 392 420.422 392 416V256C392 251.578 388.422 248 384 248ZM216 248H72V104H216V248ZM376 408H232V264H376V408ZM384 32H64C28.654 32 0 60.652 0 96V416C0 451.348 28.654 480 64 480H384C419.346 480 448 451.348 448 416V96C448 60.652 419.346 32 384 32ZM432 416C432 442.469 410.467 464 384 464H64C37.533 464 16 442.469 16 416V96C16 69.531 37.533 48 64 48H384C410.467 48 432 69.531 432 96V416Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameBoardSimple);
export default __webpack_public_path__ + "static/media/game-board-simple.e694a2d97127b8e72c2993dea034992e.svg";
export { ForwardRef as ReactComponent };